import Field from "../field"

class Form {
    constructor(el) {
        this._init(el)
    }
    _init(el) {
        this.el = el
        if(!this.el) {
            return
        }
        this.id = this.el.getAttribute('data-form')
        this.elFields = Array.from(this.el.querySelectorAll('[data-field]'))
        // this.elFields = Array.from(this.el.querySelectorAll('[data-field=' + type + ']'))
        this.fields = this.elFields.map(el => {
            el.field = new Field(el, this)
            return el.field
        })
    }
    checkValidation() {
        let isValid = true
        this.fields.forEach(field => {
            isValid = field.validate() && isValid
        })
        return isValid
    }
    toggleFieldsActive(on) {
        this.elFields.forEach(el => {
            el.disabled = on
        });
    //     if(bool) {
    //         this.elFields.forEach(el => {
    //             el.disabled = 'disabled'
    //         });
    //     } else {
    //     }
    }
}

export default Form